import React from 'react';
import loadable from '@loadable/component';
import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';
import { useLocale } from '../../hooks/useLocale';
import FallbackPage from './FallbackPage';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);
const IdealSessionForm = loadable(() =>
  import(/* webpackChunkName: "IdealSessionForm" */ '../SearchPage/IdealSessionForm/IdealSessionForm')
);

export const LandingPageComponent = props => {
  const { pageAssetsData, inProgress, error } = props;
  
  // Extraction de la locale (string) depuis l'objet retourné par useLocale()
  const { locale } = useLocale();
  
  // Sélection de l'asset selon la langue
  const ASSET_NAME = locale === 'fr' ? 'landing-page' 
                   : locale === 'nl' ? 'landing-page-nl'
                   : 'landing-page-en';
  
  return (
    <>
      <PageBuilder
        pageAssetsData={pageAssetsData?.[camelize(ASSET_NAME)]?.data}
        inProgress={inProgress}
        error={error}
        fallbackPage={<FallbackPage error={error} />}
        appendMainContent={
          <div style={{ maxWidth: '1056px', margin: '0 auto', padding: '0 24px 60px 24px' }}>
            <IdealSessionForm />
          </div>
        }
      />
    </>
  );
};

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error };
};

const LandingPage = compose(connect(mapStateToProps))(LandingPageComponent);

export default LandingPage;
